export default {
    props: {
        image: {
            type: String,
            required: false,
            default: () => {
                return '/images/induline-share.png';
            }
        },

        title: {
            type: String,
            required: true
        },

        isTop: {
            type: Boolean,
            required: false,
        },

        link: {
            type: String,
            required: true
        },

        readMore: {
            type: String,
            required: false,
            default: ''
        },
    }
}